import React, { useState } from "react";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";
import logout from "../../assets/images/logoutIcon.png";
import logoutConfirm from "../../assets/images/logout.png";
import { toast } from "react-toastify";
import Threads from "../Thread/Thread"; 
import { env } from "../../environment";

function Sidebar({ isUpdateThread }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${env.baseURL}/app-users/logout`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        toast.success("Logout successful!");
        localStorage.clear();
        setShowModal(false);
        localStorage.setItem("logout", true);
        navigate("/sign-in");
      } else {
        toast.success("Logout successful!");
        localStorage.clear();
        setShowModal(false);
        localStorage.setItem("logout", true);
        navigate("/sign-in");
      }
    } catch (error) {
      toast.success("Logout successful!");
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className="sidebar">
        <div className="navigation">
          <div className="container">
            {/* Render the Threads component here */}
            
            <Threads isUpdateThread={isUpdateThread} />
          </div>

          <div
            onClick={handleOpenModal}
            style={{ cursor: "pointer" }}
            className="nav-item-logout"
          >
            <p className="profile-name">Log Out</p>
            <span>
              <img
                style={{ position: "relative", top: "2px" }}
                src={logout}
                alt="Logout"
              />
            </span>
          </div>
        </div>
      </div>
      <LogoutModal
        show={showModal}
        handleLogout={handleLogout}
        handleClose={handleCloseModal}
      />
    </>
  );
}

export default Sidebar;

const LogoutModal = ({ show, handleLogout, handleClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={logoutConfirm} alt="Logout Icon" />
        </div>
        <div className="logout-text">Are you sure you want to Log Out?</div>
        <div className="modal-buttons">
          <button onClick={handleClose} className="no-btn">
            No
          </button>
          <button onClick={handleLogout} className="yes-btn">
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};
